var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDislikeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2787 8.61189L8.612 14.6119C8.08157 14.6119 7.57286 14.4012 7.19779 14.0261C6.82271 13.651 6.612 13.1423 6.612 12.6119V9.94523H2.83867C2.64539 9.94742 2.45396 9.90756 2.27762 9.82842C2.10128 9.74927 1.94426 9.63274 1.81743 9.48689C1.6906 9.34103 1.597 9.16935 1.54311 8.98373C1.48922 8.79811 1.47633 8.60299 1.50533 8.41189L2.42533 2.41189C2.47355 2.09396 2.63504 1.80416 2.88006 1.59589C3.12508 1.38762 3.43711 1.27493 3.75867 1.27856H11.2787M11.2787 8.61189V1.27856M11.2787 8.61189H13.0587C13.436 8.61857 13.8026 8.48647 14.0889 8.24068C14.3753 7.99489 14.5614 7.65252 14.612 7.27856V2.61189C14.5614 2.23793 14.3753 1.89556 14.0889 1.64977C13.8026 1.40398 13.436 1.27189 13.0587 1.27856H11.2787",
    stroke: "#576579",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislikeIcon);
export default __webpack_public_path__ + "static/media/dislike_icon.914d43d75cdddefebf698b9572273de8.svg";
export { ForwardRef as ReactComponent };